import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { ArrowRight, Users, Sparkles, User, FileSpreadsheet, Calculator, BookOpen } from "lucide-react";

const TILES = [
  { to: "/groepspringen/waarden", title: "Groepspringen", desc: "Reglement, waarden en sprong checker voor team sprongen", color: "from-orange-500 to-amber-500", icon: Users },
  { to: "/micro-meso/waarden", title: "Micro / Meso", desc: "Aangepaste regels voor Micro & Meso TeamGym", color: "from-emerald-500 to-teal-500", icon: Sparkles },
  { to: "/individueel/waarden", title: "Individueel", desc: "Min/max waarden en checker per turner", color: "from-slate-700 to-slate-900", icon: User },
];

const FEATURES = [
  { icon: BookOpen, t: "Compleet reglement", d: "Min/max D-waarden per niveau, leeftijd en toestel." },
  { icon: Calculator, t: "Sprong checker", d: "Voer sprongen in (zelfs afkortingen) en check direct of ze passen." },
  { icon: FileSpreadsheet, t: "Excel export", d: "Genereer automatisch een ingevuld sprongformulier." },
];

export default function Home() {
  const { user } = useAuth();
  return (
    <div data-testid="home-page">
      <div className="text-xs uppercase tracking-[0.22em] text-orange-600 font-semibold">Turnsport</div>
      <h1 className="heading-display text-5xl sm:text-6xl mt-2 leading-[0.95]">
        Check je sprongen.<br/>
        <span className="text-orange-500">Spring zonder zorgen.</span>
      </h1>
      <p className="text-lg text-slate-600 mt-4 max-w-2xl">
        Alle groepspringen-reglementen op één plek. Voer je sprongen in — wij rekenen direct of het mag.
      </p>

      <div className="grid sm:grid-cols-3 gap-3 mt-10">
        {FEATURES.map((f, i) => (
          <div key={i} className="gs-card p-5" data-testid={`feature-${i}`}>
            <f.icon className="text-orange-500" size={22}/>
            <div className="font-bold mt-2">{f.t}</div>
            <div className="text-sm text-slate-600">{f.d}</div>
          </div>
        ))}
      </div>

      <h2 className="heading-display text-2xl mt-12 mb-4">Onderdelen</h2>
      <div className="grid sm:grid-cols-3 gap-4">
        {TILES.map((t) => (
          <Link key={t.to} to={t.to} className={`group relative overflow-hidden rounded-xl p-6 text-white bg-gradient-to-br ${t.color} hover:-translate-y-1 transition-transform`} data-testid={`tile-${t.title.toLowerCase()}`}>
            <t.icon size={28} className="opacity-90"/>
            <div className="text-2xl font-bold mt-3">{t.title}</div>
            <div className="text-sm opacity-90 mt-1">{t.desc}</div>
            <div className="mt-4 flex items-center gap-2 text-sm font-medium">Open <ArrowRight size={16} className="transition-transform group-hover:translate-x-1"/></div>
          </Link>
        ))}
      </div>

      {!user && (
        <div className="gs-card p-6 mt-10 flex items-center justify-between flex-wrap gap-4" data-testid="cta-register">
          <div>
            <div className="font-bold">Sla je sprongen op</div>
            <div className="text-sm text-slate-600">Maak een gratis account aan om je sprongen op te slaan voor later.</div>
          </div>
          <Link to="/register" className="bg-orange-500 hover:bg-orange-600 text-white px-5 py-2.5 rounded-lg font-semibold">Account aanmaken</Link>
        </div>
      )}
    </div>
  );
}
